import { render, staticRenderFns } from "./PropRule.vue?vue&type=template&id=38d6a708&scoped=true&"
import script from "./PropRule.vue?vue&type=script&lang=js&"
export * from "./PropRule.vue?vue&type=script&lang=js&"
import style0 from "./PropRule.vue?vue&type=style&index=0&id=38d6a708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6a708",
  null
  
)

export default component.exports